var site = window.site || {};
var prodcat = window.prodcat || {};
var generic = window.generic || {};
var page_data = page_data || {};

prodcat.data = prodcat.data || {};
site.template = site.template || {};

(function ($) {
  Drupal.behaviors.productRecommendationsV1 = {
    attached: false,
    nodes: {},

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.init(context);
      self.attached = true;
    },

    selectors: {
      formatter: '.js-product-grid-recommendations-formatter',
      container: '.js-product-recommendations',
      carousel: '.js-product-grid-content'
    },

    init: function (context) {
      var self = this;

      self.nodes.$containers = $(self.selectors.container, context);

      self.nodes.$containers.each(function () {
        var $container = $(this);
        var placementId = $container.data('placementId');
        var eventType = $container.data('eventType');
        var resultsCount = $container.data('resultsCount');
        var googleFilter = $container.data('filter');
        var useNGGlobal = $container.data('useNgglobal');
        var dryRun = $container.data('dryRun');
        var productId = page_data?.['catalog-spp']?.products?.[0]?.PRODUCT_ID ?? '';

        // Since Google API requires string value for dryRun, converting it to a string.
        dryRun = Boolean(dryRun).toString();

        self.loadRecommendations(
          placementId,
          eventType,
          resultsCount,
          googleFilter,
          useNGGlobal,
          dryRun,
          productId,
          $container
        );
      });
    },

    loadRecommendations: function (
      placementId,
      eventType,
      resultsCount,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId,
      $container
    ) {
      var self = this;
      var params = self.buildDataObject(
        placementId,
        eventType,
        resultsCount,
        googleFilter,
        useNGGlobal,
        dryRun,
        productId
      );

      self.getRecommendations(params, $container);
    },

    buildDataObject: function (
      placementId,
      eventType,
      resultsCount,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId
    ) {
      return {
        useNGGlobal: useNGGlobal,
        dryRun: dryRun,
        eventType: eventType,
        placementId: placementId,
        pageSize: resultsCount,
        filter: googleFilter,
        productId: productId
      };
    },

    getRecommendations: function (params, $container) {
      var self = this;
      var data;

      generic.jsonrpc.fetch({
        method: 'user.googleAIRecommend',
        params: [params],
        onSuccess: function (response) {
          data = JSON.parse(response.getValue());

          if (data && data.results && data.results.length !== 0) {
            self.processResponse(data, $container);
          } else {
            $container.toggleClass('hidden');
          }
        }
      });
    },

    processResponse: function (data, $container) {
      var self = this;
      var items = [];
      var recommendationToken = data.recommendationToken;

      data.results.forEach(function (result) {
        items.push(result.id);
      });
      self.getPerlgemProductData(items, recommendationToken, $container);
      if (site.trackingDataLayer) {
        site.trackingDataLayer.update({
          aiRecommendationToken: recommendationToken
        });
      }
    },

    getPerlgemProductData: function (results, token, $container) {
      var self = this;
      var size = Unison.fetch.now().name;
      var queryParams;
      var $recommendationsGrid = $('.js-product-recommendations-grid', document);

      results.forEach(function (productId, index) {
        results[index] = productId.indexOf('PROD') !== -1 ? productId : 'PROD' + productId;
      });

      queryParams = [
        {
          method: 'prodcat.querykey',
          params: [
            {
              products: results,
              query_key: 'catalog-mpp'
            }
          ]
        }
      ];

      $.ajax({
        url: '/rpc/jsonrpc.tmpl',
        type: 'post',
        data: $.param({ JSONRPC: JSON.stringify(queryParams) })
      }).done(function (response) {
        var products;
        var rendered;
        var $productBriefs;
        var $sppLink;
        var appendToken;
        var href;
        var newHref;
        var prodData = [];
        var i;
        var productObj = [];

        productObj.products = [];
        if (response.length > 0 && Boolean(response[0].result.value)) {
          products = _.compact(response[0].result.value.products);
          prodcat.data.updateProducts(products);
          products.forEach(function (product) {
            var defaultSku;
            var skuLength;
            var sku;
            var productData = prodcat.data.getProduct(product.PRODUCT_ID);
            if (!productData && !productData['skus']) {
              return;
            }
            skuLength = productData['skus'].length;
            for (i = 0; i < skuLength; i++) {
              sku = productData['skus'][i];
              if (sku['DEFAULT_SKU'] === 1) {
                defaultSku = sku;
                break;
              }
            }
            if (!defaultSku) {
              defaultSku = productData['skus'][0];
            }
            productData['defaultSku'] = defaultSku;
            prodData.push(productData);
          });
          prodcat.data.updateProducts(prodData);
          productObj.products = prodData;
          rendered = site.template.get({
            name: 'product_grid',
            data: productObj
          });

          $container.find('.js-product-recommendations-grid').append(rendered).show();
          $(document).trigger('product.gridLoaded', $recommendationsGrid);
          $(document).trigger('recommended.gridLoaded', $recommendationsGrid);
          $('.js-product', $recommendationsGrid).trigger('product.init');
          $container
            .closest(self.selectors.formatter)
            .find('.tout__header')
            .addClass('show-recommendation');
          self.setCarousel($container);
          if (Drupal?.behaviors?.quickshopOverlay) {
            Drupal.behaviors.quickshopOverlay.initializeGrid($('.js-product-grid', $container), size);
          }

          appendToken = function ($link) {
            href = $link.attr('href');

            if (typeof href !== 'undefined' && href !== '' && href.indexOf('rtoken') === -1) {
              newHref = href + '/?rtoken=' + token;
              $link.attr('href', newHref);
            }
          };

          $productBriefs = $('.js-product-brief', $container);
          if ($productBriefs.length > 0) {
            $productBriefs.each(function () {
              $sppLink = $('.js-spp-link', $(this));
              appendToken($sppLink);
            });
          }
          $(document).trigger('products.init-finish');
        }
      });
    },

    setCarousel: function ($container) {
      var self = this;
      var $carousels = $(self.selectors.carousel, $container);
      var $carouselItem = $('.js-grid-item', $carousels);
      var initSlider = $carouselItem.length > 1;
      var $arrowsDiv = $container.find('.js-carousel-controls');
      var settings;
      var contentWidth = Unison.fetch.all();
      var mobileWidth = parseInt(contentWidth.small, 10);
      var ipadWidth = parseInt(contentWidth.portrait, 10);
      var pcWidth = parseInt(contentWidth.landscape, 10);

      if (!initSlider) {
        return;
      }

      settings = {
        appendArrows: $arrowsDiv,
        infinite: true,
        mobileFirst: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: pcWidth,
            settings: {
              slidesToShow: Math.min(4, $carouselItem.length),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: ipadWidth,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: mobileWidth,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

      $container.find('.js-product-grid').addClass('product-grid--carousel');
      $carousels.not('.slick-initialized').slick(settings);
    }
  };
})(jQuery);
